import { useEffect, useState } from 'react';
import { getSettings } from '../Services/CatalogApi';
import { DEFAULT_LIMITS } from '../Services/contentModel';
import { limitsFromSettings } from '../Services/settingsModel';

/**
 * Os limites de tamanho em vigor (tela de Configuração) para os editores de conteúdo. Enquanto carrega, ou se a leitura falhar, valem os padrões:
 * a tela nunca fica sem contador, e quem decide de verdade ao pedir a publicação é o servidor.
 */
export default function useCatalogLimits() {
    const [limits, setLimits] = useState(DEFAULT_LIMITS);

    useEffect(() => {
        let alive = true;
        getSettings().then((view) => { if (alive) setLimits(limitsFromSettings(view?.settings)); }).catch(() => {});
        return () => { alive = false; };
    }, []);

    return limits;
}
